// extracted by mini-css-extract-plugin
module.exports = {"wk99p5d":"wk99p5d","s1ifpwuy":"s1ifpwuy","hjgdu10":"hjgdu10","h1g0qwxd":"h1g0qwxd"};